import { Button } from "@/shared/ui/button.tsx";
import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog.tsx";
import { Copy, Download, Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";

type Props = {
  currentImg: string,
  image_video_recommendation: string,
  image_id: number
}

const ImageDialog = ({ currentImg, image_video_recommendation , image_id }: Props) => {

  const navigate = useNavigate()

  return (
    <Dialog>
      <DialogTrigger>
        <div className="size-full relative group">
          <img
            src={currentImg}
            loading="lazy"
            className="w-full h-fit rounded-lg cursor-pointer"
            alt="Preview"
            width="500px"
            height="500px"
          />
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-2xl bg-black text-purple-500 font-semibold border-none outline-black p-0">
        <div className="absolute bottom-2 right-2 flex items-center gap-2">
          <Button size="icon"
            title="Download Image"
            className=""
            onClick={() => {
              const link = document.createElement('a');
              link.href = currentImg;
              link.download = currentImg.split('/').pop() || 'image';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}>
            <Download />
          </Button>
          <Button size="icon"
            onClick={() => {
              navigator.clipboard.writeText(image_video_recommendation)
            }}
          >
            <Copy />
          </Button>
          <Button size="icon"
            onClick={() => {
              navigate(`/home/gallery/${image_id}`)
            }}
        >
          <Pencil />
        </Button>
        </div>
        <img src={currentImg} className="w-full h-auto rounded-lg" alt="Full View" />
      </DialogContent>
    </Dialog>
  )
}

export default ImageDialog
